import { AppState } from 'common/store'
import React, { useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'
import { AuthenticationState } from 'common/data/authentication/reducer'
import { RenderTargetContext } from 'common/context-providers/render-target-context'
import { THEWEST_ALL } from './common'

interface EntitledToViewProps {
    isPremium: boolean
    /** slug to check against mmo referrer slug to allow access */
    articleSlug?: string
    entitled: () => React.ReactElement<any> | null
    notEntitled?: (loginStatusChecked: boolean) => React.ReactElement<any> | null
    onIsEntitledChange?: (event: { entitled: boolean; loggedInStatusChecked: boolean }) => void
}

function entitledToViewPublication(authentication: AuthenticationState, slug?: string) {
    if (authentication.entitlements.indexOf(THEWEST_ALL) >= 0) {
        return true
    }

    if (typeof slug !== 'undefined' && authentication.mmoArticleSlug === slug) {
        return true
    }

    // for topic paywall, we could pass in a list of entitlements and the primary (or secondary) topics.
    // then could look for an entitlement to 'thewest:all' or 'thewest:<topic>', or some other mapping
    return false
}

export const EntitledToView: React.FC<EntitledToViewProps> = ({
    isPremium,
    entitled,
    notEntitled,
    onIsEntitledChange,
    articleSlug,
}) => {
    const renderTarget = useContext(RenderTargetContext)
    const authentication = useSelector<AppState, AuthenticationState>(
        ({ authentication }) => authentication
    )
    const isEntitled =
        !isPremium ||
        entitledToViewPublication(authentication, articleSlug) ||
        renderTarget.renderTarget === 'preview'

    useEffect(() => {
        if (onIsEntitledChange) {
            onIsEntitledChange({
                entitled: isEntitled,
                loggedInStatusChecked: authentication.hasAttemptedValidation,
            })
        }
        // Ignoring eslint-disable-next-line react-hooks/exhaustive-deps for this effect
        // because it will continue to trigger. We can come back and look at useCallback and
        // resolving the issue. Any news deps should still be added
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEntitled, authentication.hasAttemptedValidation])

    return isEntitled
        ? entitled()
        : notEntitled
        ? notEntitled(authentication.hasAttemptedValidation)
        : null
}
